import React from 'react';

import AppStoreBadges from '@components/AppStoreBadges';
import IconTIApp from '@components/Images/Rebranding/IconTIApp';
import LazyImgixImage from '@components/LazyImgixImage';

import { APP_IMAGE_URL } from './constants';

const AppSection = () => (
  <section className="md:max-w relative mx-auto w-full border-0 border-b border-solid border-grayscale-charcoal pt-64 sm:max-w-[1040px] md:pt-112 xl:max-w-[1130px]">
    <div className="mx-auto flex max-w-[900px] flex-col items-center gap-32 sm:gap-64 md:flex-row">
      <LazyImgixImage
        className="mx-auto block h-auto w-full max-w-[310px]"
        src={APP_IMAGE_URL}
        wrapperClassName="order-2 md:order-1 md:self-end"
      />

      <div className="order-1 flex flex-col items-start gap-24 md:order-2 md:max-w-[500px]">
        <IconTIApp className="h-80 w-auto" />
        <div className="flex flex-col gap-8">
          <h2 className="m-0 font-suisse-works text-headline-xxs text-primary-black sm:text-headline-sm md:text-headline-md">
            The Information App
          </h2>
          <p className="m-0 font-suisse-neue text-body-lg text-primary-black">
            Before the market catches on, get the story in The Information app. Stay ahead with
            breaking tech and finance news alerts, Deep Research on your questions and hear from our
            journalists who break the stories everyone else follows. Personalize your coverage and
            listen to every story wherever you are.
          </p>
        </div>
        <AppStoreBadges />
      </div>
    </div>
  </section>
);

export default AppSection;
